const translations = {
  en: {
    translation: {
      'general.btn.home': 'home',
      'general.btn.page': 'page',
      'general.btn.delete': 'Delete',
      'general.btn.cancel': 'Cancel',
      'general.error.invalidFormat': 'Invalid input format. Only a-zA-Z0-9äöüÄÖÜß-()/ and spaces are allowed.',
      'general.error.invalidNumber': 'Invalid number format.',
      'general.error.onlyIntegerAllowed': 'Only whole numbers are allowed',
      'general.error.required': 'is required',
      'general.error.requiredField': 'Field is required',
      'general.error.characterLimit': 'Input is too long, character limit is 255',
      'general.error.dateSelect': 'Select a date',
      'general.error.valueSelect': 'Select a value',
      'general.error.noDataFound': 'No data found.',
      'general.error.integer': 'Must be an integer.',
      'general.error.positive': 'Must be positive.',
      'general.error.latitude': 'Latitude must have max 2 integers and max 6 decimal digits.',
      'general.error.longitude': 'Longitude must have max 3 integers and max 6 decimal digits.',
      'general.error.noiseThreshold': 'Number must be positive, have max 3 integer digits and max 5 decimal digits.',
      'general.error.invalidDate': 'Date must be in the past',
      'general.error.invalidDateActiveTo': 'Date must be after "active from" ',
      'general.error.maximumSelectedOptions': 'The maximum number of selected options is',
      'general.error.noDataDescription':
        'For the choosen parameters no data was found. Please adjust your parameters and try again.',
      'general.error.endAfterStart': 'End date must be after start date',
      'general.error.timePeriodToSmall': 'Start date must be further in the past, selected time period is too small',
      'general.label.discard': 'Discard',
      'general.label.resetAll': 'Reset All',
      'general.label.apply': 'Apply',
      'management.general.discard': 'Discard changes',
      'management.general.cancel': 'Cancel',
      'management.general.save': 'Save',
      'management.general.create': 'Create',
      'general.tooltip.resetAll': 'Reset All',
      'general.tooltip.addNewRow': 'Add new row',
      'general.tooltip.editRow': 'Edit row',
      'general.tooltip.removeRow': 'Remove row',
      'general.tooltip.duplicateRow': 'Duplicate row',
      'general.tooltip.export': 'Export as csv',
      'general.tooltip.exportAllRows': 'Export All Rows',
      'general.tooltip.exportAll': 'Export All',
      'general.label.noSubcategoryFound': 'No subcategory',
      'general.grid.noRows': 'No rows',
      'general.grid.noMatchingRows': 'No matching rows',
      'home.title': 'Home',
      'page.title': 'Page',
      'notFound.title': 'Not Found',
      'navbar.menu.monitoring': 'Monitoring',
      'navbar.menu.monitoring.import': 'Data import',
      'navbar.menu.monitoring.measurementVisualization': 'Measurement visualization',
      'navbar.menu.monitoring.measurementExport': 'Measurement Export',
      'navbar.menu.analyses': 'Analyses',
      'navbar.menu.analyses.pqIndex': 'PQ-Index',
      'navbar.menu.analyses.harmonicBackgroundLevel': 'Harmonic Background Level',
      'navbar.menu.analyses.anomalies': 'Anomalies',
      'navbar.menu.analyses.trend': 'Trend',
      'navbar.menu.analyses.correlation': 'Correlation',
      'navbar.menu.analyses.risk': 'Risk',
      'navbar.menu.analyses.fluctuation': 'Fluctuation',
      'navbar.menu.analyses.volatility': 'Volatility',
      'navbar.menu.administration': 'Administration',
      'navbar.menu.administration.measuringPointManagement': 'Measurement Point ',
      'navbar.menu.administration.masterData': 'Master Data',
      'navbar.menu.administration.limitManagement': 'Limit Management',
      'navbar.menu.admin': 'Administration',
      'navbar.menu.deviceadministration': 'Device Administration',
      'navbar.menu.masterdata': 'Master Data',
      'user.menu.changeUser': 'Change User',
      'user.menu.logOut': 'Log Out',
      'user.menu.role': 'Role',
      'calendar.month.jan': 'January',
      'calendar.month.feb': 'February',
      'calendar.month.mar': 'March',
      'calendar.month.apr': 'April',
      'calendar.month.may': 'May',
      'calendar.month.jun': 'June',
      'calendar.month.jul': 'July',
      'calendar.month.aug': 'August',
      'calendar.month.sep': 'September',
      'calendar.month.oct': 'October',
      'calendar.month.nov': 'November',
      'calendar.month.dec': 'December',
      'calendar.button.accept': 'Accept selection',
      'searchfield.placeholder': 'Search for substation, measurement point or measurement device',
      'searchfield.search': 'Search',
      'searchfield.noResult': 'No results found. Please adjust your search.',
      'dropzone.description': 'Select a file to upload by clicking the + button or dragging and dropping it here.',
      'dropzone.drag': 'Drop the files here...',
      'management.menu.collapseButton.tooltip.collapse': 'Collapse All',
      'management.menu.collapseButton.tooltip.expand': 'Expand All',
      'management.menu.title': 'Measuring point management',
      'management.placeholderTitle': 'Nothing selected.',
      'management.placeholderDescription': 'Choose a substation, a measurement point or a measurement device',
      'management.substation.tooltip.createSubstation': 'Add substation',
      'management.substation.create.title': 'Create new Substation',
      'management.substation.subtitle': 'Substation',
      'management.substation.designation': 'Designation',
      'management.substation.latitude': 'Latitude',
      'management.substation.latitude.error': 'Latitude must be a number between -90 and 90',
      'management.substation.longitude': 'Longitude',
      'management.substation.longitude.error': 'Longitude must be a number between -180 an 180',
      'management.substation.comment': 'Comment',
      'management.measurementPoint.substationDeleteTitle': 'Delete substation',
      'management.measurementPoint.substationDeleteContent':
        'Are you sure you want to delete this substation? This action cannot be undone.',
      'management.measurementPoint.substationCannotDelete': 'Cannot be deleted because it has measurement points',
      'management.measurementPoint.active': 'Active',
      'management.measurementPoint.activFrom': 'Active from',
      'management.measurementPoint.activeUntil': 'Active until',
      'management.measurementPoint.subtitle': 'Measuring Point',
      'management.measurementPoint.designation': 'Designation',
      'management.measurementPoint.converterTypeVoltage': 'Transducer model voltage',
      'management.measurementPoint.converterTypeCurrent': 'Transducer model current',
      'management.measurementPoint.transducerModelNotAvailable': '-',
      'management.measurementPoint.transducerModelDeleteTitle': 'Delete transducer model',
      'management.measurementPoint.transducerModelDeleteContent':
        'Are you sure you want to delete this transducer model? This action cannot be undone.',
      'management.measurementPoint.transducerModelCannotDelete':
        'Cannot be deleted because it is referenced in measurement point',
      'management.measurementPoint.voltageLevel': 'Voltage level',
      'management.measurementPoint.connectionPointType': 'Connection point type',
      'management.measurementPoint.connectionPointType.transformer': 'Transformer',
      'management.measurementPoint.connectionPointType.powerline': 'Power line',
      'management.measurementPoint.connectionPointType.plant': 'Plant',
      'management.measurementPoint.comment': 'Comment',
      'management.measurementPoint.create.button.tooltip': 'Add measurement point',
      'management.measurementPoint.create.title': 'Create new measurement point',
      'management.measurementPoint.measurementPointDeleteTitle': 'Delete measurement point',
      'management.measurementPoint.measurementPointDeleteContent':
        'Are you sure you want to delete this measurement point? This action cannot be undone.',
      'management.measurementPoint.measurementPointCannotDelete':
        'Cannot be deleted because it has measurement devices',
      'management.measurementPoint.history.title': 'Measurement Point History',
      'management.measurementPointHistory.designation': 'Designation',
      'management.measurementDevice.create.button.tooltip': 'Add measurement device',
      'management.measurementDevice.create.title': 'Create new measurement device',
      'management.measurementDevice.history.title': 'Measurement Device History',
      'management.measurementDevice.subtitle': 'Measurement Device',
      'management.measurementDevice.designation': 'Designation',
      'management.measurementDevice.technicalIdentifier': 'Technical Identifier',
      'management.measurementDevice.error.invalidFormat': 'Invalid input format. Only a-zA-ZäöüÄÖÜß0-9 are allowed.',
      'management.measurementDevice.activationStart': 'Active from',
      'management.measurementDevice.activationEnd': 'Active until',
      'management.measurementDevice.manufactureYear': 'Manufacture Year',
      'management.measurementDevice.deviceTypes': 'Measurement device model',
      'management.measurementDevice.manufacturer': 'Manufacturer',
      'management.measurementDevice.noiseLimit': 'Noise limit',
      'management.measurementDevice.includeForAnalyses.title': 'Include measurement device for the following analyses:',
      'management.measurementDevice.includeForAnalyses.corellationLabel': 'Correlation Analysis',
      'management.measurementDevice.includeForAnalyses.anomalyDetectionLabel': 'Anomaly Detection',
      'management.measurementDevice.comment': 'Comment',
      'management.measurementDevice.measurementDeviceDeleteTitle': 'Delete measurement device',
      'management.measurementDevice.measurementDeviceDeleteContent':
        'Are you sure you want to delete this measurement device? This action cannot be undone.',
      'management.measurementDevice.measurementDeviceConfirmationDelete':
        'Deleting this measurement device will also delete its measurement data.',
      'masterdata.management': 'Master Data management',
      'masterdata.cancel': 'Cancel',
      'masterdata.delete': 'Delete',
      'masterdata.generalPlaceholder': 'Please enter value',
      'masterdata.generalLimitationHasData': 'Value cannot be changed because entity has data uploaded',
      'masterdata.transducer.modal.title': 'Add new transducer model type',
      'masterdata.transducer.modal.titleEdit': 'Edit transducer model type',
      'masterdata.transducer.section': 'Transducer model',
      'masterdata.transducer.table.manufacturer': 'Manufacturer',
      'masterdata.transducer.table.model': 'Model',
      'masterdata.transducer.table.transducerModel': 'Type',
      'masterdata.transducer.table.transducerModel.combined': 'Combined',
      'masterdata.transducer.table.transducerModel.voltage': 'Voltage',
      'masterdata.transducer.table.transducerModel.current': 'Current',
      'masterdata.transducer.table.transmissionRatio': 'Transformer ratio',
      'masterdata.transducer.table.transmissionRatioVoltage': 'Transformer ratio voltage',
      'masterdata.transducer.table.transmissionRatioCurrent': 'Transformer ratio current',
      'masterdata.transducer.table.transmissionRatioFormat': 'Insert the value as follows: xxx:xx',
      'masterdata.transducer.table.voltagefrequencyDeviationPhaseAngle1': 'Voltage phase angle error 1% (Hz)',
      'masterdata.transducer.table.voltagefrequencyDeviationPhaseAngle10': 'Voltage phase angle error 10% (Hz)',
      'masterdata.transducer.table.voltagefrequencyDeviationMagnitude1': 'Voltage amplitude error 1% (Hz)',
      'masterdata.transducer.table.voltagefrequencyDeviationMagnitude10': 'Voltage amplitude error 10% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationPhaseAngle1': 'Current phase angle error 1% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationPhaseAngle10': 'Current phase angle error 10% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationMagnitude1': 'Current amplitude error 1% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationMagnitude10': 'Current amplitude error 10% (Hz)',
      'masterdata.transducer.table.frequencyDeviationMagnitude1': 'amplitude error 1% (Hz)',
      'masterdata.transducer.table.frequencyDeviationMagnitude10': 'amplitude error 10% (Hz)',
      'masterdata.transducer.table.frequencyDeviationPhaseAngle1': 'phase angle error 1% (Hz)',
      'masterdata.transducer.table.frequencyDeviationPhaseAngle10': 'phase angle error 10% (Hz)',
      'masterdata.transducer.table.comment': 'Comment',
      'masterdata.transducer.modal.type.voltage': 'Voltage',
      'masterdata.transducer.modal.type.current': 'Current',
      'masterdata.transducer.modal.type.combined': 'Combined',
      'masterdata.voltageLevel.section': 'Voltage level',
      'masterdata.voltageLevel.modal.title': 'Add new voltage level',
      'masterdata.voltageLevel.modal.titleEdit': 'Edit voltage level',
      'masterdata.voltageLevel.table.voltageLevelName': 'Name',
      'masterdata.voltageLevel.table.voltageLevelValue': 'Voltage value LL (kV)',
      'masterdata.voltageLevel.table.comment': 'Comment',
      'masterdata.voltageLevel.deleteTitle': 'Delete voltage level',
      'masterdata.voltageLevel.deleteContent':
        'Are you sure you want to delete this voltage level? This action cannot be undone.',
      'masterdata.voltageLevel.cannotDelete': 'Cannot be deleted because it is reference in measurement point',
      'masterdata.measuringDeviceType.section': 'Measurement device model',
      'masterdata.measuringDeviceType.modal.title': 'Add new measurement device model',
      'masterdata.measuringDeviceType.modal.titleEdit': 'Edit measurement device model',
      'management.measurementDevice.technicalIdentifierPlaceholder': 'Enter value',
      'masterdata.measuringDeviceType.table.manufacturer': 'Manufacturer',
      'masterdata.measuringDeviceType.table.model': 'Model',
      'masterdata.measuringDeviceType.table.noiseLimitVoltage': 'Noise limit voltage (V)',
      'masterdata.measuringDeviceType.table.noiseLimitCurrent': 'Noise limit current (A)',
      'masterdata.measuringDeviceType.noiseLimit.supportingText':
        'Analyses will only be run for measurement devices with noise thresholds.',
      'masterdata.measuringDeviceType.table.comment': 'Comment',
      'masterdata.measuringDeviceType.deleteTitle': 'Delete measurement device type',
      'masterdata.measuringDeviceType.deleteContent':
        'Are you sure you want to delete this measurement device type? This action cannot be undone.',
      'masterdata.measuringDeviceType.cannotDelete': 'Cannot be deleted because it is referenced in measurement device',
      'upload.searchPlaceholder': 'Search for Name and Measurement Device',
      'upload.pageTitle': 'Data import',
      'upload.tableHeader.uploadType': 'Upload Type',
      'upload.tableHeader.uploadTypeDescription': 'Upload Type: \n M = Manual \n A = Automatic',
      'upload.tableHeader.fileName': 'File Name',
      'upload.tableHeader.uploadedOn': 'Uploaded on',
      'upload.tableHeader.startPeriod': 'Start period',
      'upload.tableHeader.endPeriod': 'End period',
      'upload.tableHeader.substation': 'Substation',
      'upload.tableHeader.measuringDevice': 'Measurement device',
      'upload.tableHeader.aggregationInterval': 'Aggregation interval',
      'upload.tableHeader.validityCheck': 'Validity check',
      'upload.tableHeader.status': 'Status',
      'upload.tableHeader.importStatus': 'Import status',
      'upload.fileUpload.title': 'Upload Files',
      'upload.fileUpload.cancel': 'Cancel',
      'upload.fileUpload.closeWindow': 'Close',
      'upload.fileUpload.upload': 'Upload',
      'upload.fileUpload.selectFile.description':
        'To import your files, please upload them here. We will perform a validity check prior to the import process.\nCurrently the system can process exported CSV files from WinPQ and WebPQ.\nIf naming the file according to the following schemes, measurement device and aggregation interval can be assigned automatically.\nScheme of WinPQ-filename: "<SetupName>_<ExportDate>_<TechnicalNameMeasurementDevice>_<TechnicalNameAggregationInterval>1_2.csv" where the aggregation interval can be "C2h", "C10m_v" or "C10m_c".\nScheme of WebPQ-filename: "<startDate><endDate><technicalNameAggregationInterval>.csv" where aggregationInterval can be "c2h", "c10m_v" or "c10m_c". The measurement device will be extracted from the file content.',
      'upload.fileUpload.selectFile.added': 'Added Files',
      'upload.fileUpload.uploadingFile.description':
        'Your files are being uploaded. Please wait while we process them and check for any issues before completing the import. You can close the window - the upload process will not be interrupted. Errors will be displayed in the snackbar.',
      'upload.fileUpload.uploadingFile.errorList.title':
        'The following files encountered errors during the upload process:',
      'upload.fileUpload.uploadingFile.progress': '[currentFile] out of [totalFiles] files were uploaded successfully.',
      'upload.fileUpload.uploadingFile.error': 'Error: Unexpected Error',
      'homepage.title.development.local': 'Welcome to the test environment of\n the PQ platform!',
      'homepage.title.dev': 'Welcome to the test environment of\n the PQ platform!',
      'homepage.title.test': 'Welcome to the test environment of\n the PQ platform!',
      'homepage.title.stg': 'Welcome to the test environment of\n the PQ platform!',
      'homepage.title.prod': 'Welcome to the production environment of\n the PQ platform!',
      'homepage.description':
        'This test environment gives you the opportunity to try out the latest functions of our Power Quality Platform in a secure environment.',
      'homepage.footer.description': 'Supported by',
      'homepage.testCases.title': 'New for testing:',
      'homepage.testCases.first': '',
      'homepage.testCases.second': '',
      'homepage.testCases.third': '',
      'upload.fileUpload.uploadingFile.typeError': 'Unsupported format. Only CSV files are accepted.',
      'upload.detailedView.title': 'Measurement Import Details',
      'upload.detailedView.breadcrumb1': 'Data import',
      'upload.detailedView.breadcrumb2': 'Examination details',
      'upload.detailedView.substation': 'Substation',
      'upload.detailedView.measurementDevice': 'Measurement device',
      'upload.detailedView.pleaseSelect': 'Please select',
      'upload.detailedView.totalPeriod': 'Total period',
      'upload.detailedView.aggregationInterval': 'Aggregation interval',
      'upload.detailedView.validityCheck': 'Validity check',
      'upload.detailedView.importProcess': 'Import process',
      'upload.detailedView.validityCheckDetails.success': 'All checks passed, the file has been successfully imported.',
      'upload.detailedView.validityCheckDetails.partial':
        'The file was only partially imported due to errors in the following periods. Please fix these issues and re-upload the file.',
      'upload.detailedView.validityCheckDetails.error': 'Unable to import the file.',
      'upload.detailedView.validityCheckDetails.error.button.overwrite': 'Overwrite data',
      'upload.detailedView.validityCheckDetails.error.button.noOverwrite': 'Keep existing data',
      'upload.detailedView.validityCheckDetails.error.button.tryAgain': 'Try again',
      'upload.detailedView.validityCheckDetails.unknown': 'Unknown',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.missing': 'Missing information',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.additional':
        'Additional information is required to perform a validity check.',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.measuringDevice':
        'Missing assignment to the Measurement device',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.aggregation':
        'Missing assignment to the aggregation interval',
      'upload.detailedView.validityCheckDetails.unknownColumns': 'Unknown columns',
      'upload.detailedView.validityCheckDetails.columnsDetails':
        'The uploaded file contains columns that are not recognized.',
      'upload.detailedView.plausibilityCheck': 'Plausibility Check',
      'upload.detailedView.plausibilityCheck.status.error.name': 'n/a',
      'upload.detailedView.plausibilityCheck.status.error.message':
        'An error has occurred during the validity check, so the plausibility check will not be executed.',
      'upload.detailedView.plausibilityCheck.status.waiting.name': 'Waiting for validation',
      'upload.detailedView.plausibilityCheck.status.waiting.message':
        'Right now, the plausibility check is on hold until the validation process is finished.',
      'upload.detailedView.plausibilityCheck.status.checking.name': 'In progress',
      'upload.detailedView.plausibilityCheck.status.checking.message':
        'The plausibility check is currently in progress.',
      'upload.detailedView.plausibilityCheck.status.plausible.name': 'Plausible',
      'upload.detailedView.plausibilityCheck.button.retry': 'Try again',
      'upload.detailedView.plausibilityCheck.status.warning.title': 'Adjust plausibility criteria',
      'upload.detailedView.plausibilityCheck.status.plausible.message':
        'All checks passed, the file has been successfully imported.',
      'upload.detailedView.plausibilityCheck.status.plausible.error':
        'An unknown error has occurred. Please try again. If the problem still occurs, you can submit a ticket.',
      'upload.detailedView.plausibilityCheck.status.notPlausible.name': 'Not Plausible',
      'upload.detailedView.plausibilityCheck.status.notPlausible.message':
        'There are time periods that do not meet the plausibility criteria. If you want to modify the decision, you can do so in the "Is plausible" section.',
      'upload.detailedView.plausibilityCheck.status.notPlausible.discardButton': 'Discard Changes',
      'upload.detailedView.plausibilityCheck.status.notPlausible.applyButton': 'Apply Changes',
      'upload.detailedView.plausibilityCheck.dataGrid.id': 'ID',
      'upload.detailedView.plausibilityCheck.dataGrid.start': 'Start',
      'upload.detailedView.plausibilityCheck.dataGrid.end': 'End',
      'upload.detailedView.plausibilityCheck.dataGrid.plausibilityRule': 'Plausibility Rule',
      'upload.detailedView.plausibilityCheck.dataGrid.plausibility': 'Is Plausible',
      'upload.detailedView.plausibilityCheck.error.title': 'Processing error',
      'upload.detailedView.import.error.title': 'Processing error',
      'upload.detailedView.import.error.content': 'The file contents could not be imported.',
      'upload.importStatus.waitingForImport': 'Waiting for import',
      'upload.importStatus.importing': 'Importing',
      'upload.importStatus.error': 'Error in import',
      'upload.importStatus.imported': 'Imported',
      'upload.importStatus.partiallyImported': 'Partially imported',
      'upload.importStatus.commonStatus.onHold': 'On Hold',
      'upload.importStatus.commonStatus.inProgress': 'In progress',
      'upload.importStatus.commonStatus.error': 'Error',
      'upload.importStatus.commonStatus.warning': 'Warning',
      'upload.importStatus.commonStatus.success': 'Success',
      'upload.importStatus.commonLabel.validation': 'Validity Check: ',
      'upload.importStatus.commonLabel.import': 'Import Process: ',
      'upload.importStatus.commonLabel.plausibility': 'Plausibility Check: ',
      'upload.importStatus.commonLabel.quantile': 'Quantile Calculation: ',
      'upload.validationStatus.error': 'Error in validation',
      'upload.validationStatus.imported': 'Imported',
      'upload.validationStatus.waitingForImport': 'Waiting for import',
      'upload.validationStatus.importing': 'Importing',
      'upload.validationStatus.partial': 'Partially imported',
      'upload.validationStatus.checkingValidity': 'Validating',
      'upload.validationStatus.waitingForValidation': 'Waiting for validation',
      'upload.validationStatus.error.unexpectedErrorUnknown': 'Unknown error',
      'upload.validationStatus.error.unexpectedError':
        'An unexpected error has occurred. Please reach out to our support team for assistance.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploaded': 'Data already available',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedDetails':
        'For this substation and measurement device, data already exists for the time period provided in the uploaded file. Reimporting the file can replace all existing values within this period. Choosing not to overwrite will continue the import with the remaining valid data.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedInTotal_other':
        '\nIn total <strong>{{count}} entries</strong> will be overwritten.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedInTotal_one':
        '\nIn total <strong>{{count}} entry</strong> will be overwritten.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedModalTitel': 'Overwrite existing data',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedModalContent_other':
        'Existing values in the system will be replaced with the data from the uploaded file. A\ntotal of <strong>{{count}} entries</strong> will be overwritten within the affected time period. This action \n cannot be undone. Are you sure you want to proceed?',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedModalContent_one':
        'Existing value in the system will be replaced with the data from the uploaded file. A\ntotal of <strong>{{count}} entry</strong> will be overwritten within the affected time period. This action \n cannot be undone. Are you sure you want to proceed?',
      'upload.detailedView.validityCheckDetails.applicationError': 'Processing error',
      'upload.detailedView.validityCheckDetails.applicationErrorDetails':
        'An unknown error has occurred. Please try again. If the problem still occurs, you can submit a ticket.',
      'upload.detailedView.validityCheckDetails.duplicateRows': 'Duplicates',
      'upload.detailedView.validityCheckDetails.duplicateRowDetails':
        'The entries with these timestamps are duplicates.',
      'upload.detailedView.validityCheckDetails.invalidTimesStamps': 'Invalid timestamps',
      'upload.detailedView.validityCheckDetails.invalidTimestampDetails': 'Some timestamps are invalid.',
      'upload.detailedView.validityCheckDetails.cannotParse': 'Unable to parse',
      'upload.detailedView.validityCheckDetails.cannotParseDetails': 'The file could not be parsed.',
      'upload.detailedView.validityCheckDetails.cannotImport': 'Unable to import',
      'upload.detailedView.validityCheckDetails.cannotImportDetails': 'The file contents could not be imported.',
      'upload.detailedView.validityCheckDetails.invalidColumnNames': 'Unknown Columns ',
      'upload.detailedView.validityCheckDetails.invalidColumnNamesDetails':
        'The following column names could not be assigned to any measurement:',
      'upload.detailedView.accordion.infoContent.validation.inProgress':
        'The imported file is being checked for validity. Please wait.',
      'upload.detailedView.accordion.infoContent.validation.success':
        'The imported file has been successfully validated.',
      'upload.detailedView.accordion.infoContent.validation.warning':
        'The imported file has been validated, but with warnings.',
      'upload.detailedView.accordion.infoContent.validation.error':
        'Unable to proceed with the validity check with the imported file due to errors.',
      'upload.detailedView.accordion.infoContent.import.onHold':
        'The import process is on hold until errors in validity check have been corrected.',
      'upload.detailedView.accordion.infoContent.import.inProgress':
        'The data from the file is being imported. Please wait.',
      'upload.detailedView.accordion.infoContent.import.error':
        'Unable to proceed with the import of the file due to errors.',
      'upload.detailedView.accordion.infoContent.import.success': 'The file has been successfully imported.',
      'upload.detailedView.accordion.infoContent.import.warning': 'The file was only partially imported due to errors.',
      'upload.detailedView.accordion.infoContent.plausibility.onHold':
        'The plausibility check is on hold until previous processes are finished.',
      'upload.detailedView.accordion.infoContent.plausibility.inProgress':
        'The imported file is being checked for plausibility. Please wait.',
      'upload.detailedView.accordion.infoContent.plausibility.error':
        'Unable to proceed with the plausibility check of the imported file due to errors.',
      'upload.detailedView.accordion.infoContent.plausibility.success':
        'The imported file has been successfully checked for plausibility.',
      'upload.detailedView.accordion.infoContent.plausibility.warning':
        'The imported file has been checked for plausibility. There is the option to manually adjust the plausibility criteria. Please restart the quantile calculation afterwards.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.onHold':
        'The quantile calculation process is on hold until previous processes are finished.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.inProgress':
        'The quantiles are being calculated. Please wait.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.success':
        'The quantiles have been successfully calculated and can now be used for the PQ-Index.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.error':
        'Unable to proceed with the quantile calculation of the imported file due to errors.',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent': 'Quantile Calculation',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.success.title':
        'Re-calculate if changes have been made to plausibility check',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.success.content':
        'If you have manually adjusted the plausibility criteria, you can restart the quantile calculation process here.',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.success.buttonLabel': 'Restart calculation',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.error.title': 'Processing error',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.error.content':
        'An unknown error has occurred. Please try again. If the problem still occurs, you can submit a ticket.',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.error.buttonLabel': 'Retry calculation',
      'upload.type.manual': 'M',
      'upload.type.auto': 'A',
      'upload.noFile': 'No file selected',
      'upload.notAvailable': 'Not available',
      'upload.aggregationinterval.2hours': '2 hours',
      'upload.aggregationinterval.10minutes': '10 minutes',
      'upload.aggregationinterval.10minutes.voltage': '10 minutes voltage',
      'upload.aggregationinterval.10minutes.current': '10 minutes current',
      'upload.chipFilter.quickFilters': 'Quick Filters:',
      'upload.chipFilter.success': 'Success',
      'upload.chipFilter.warning': 'Warning',
      'upload.chipFilter.error': 'Error',
      'measurementVisualization.pageTitle': 'Change Parameters for data visualization or export',
      'measurementVisualization.visualizationSectionTitle': 'Applied Parameters Overview',
      'importedMeasurementOverview.chart.placeholder.title': 'No parameters selected.',
      'importedMeasurementOverview.chart.placeholder.descri': 'Choose parameters to visualize it as a chart.',
      'measurementVisualization.table.measurementDevice': 'Measurement Device',
      'measurementVisualization.table.aggregationInterval': 'Aggregation Interval',
      'measurementVisualization.form.submit': 'Apply',
      'measurementVisualization.form.discard': 'Reset All',
      'measurementVisualization.table.start': 'Start (UTC)',
      'measurementVisualization.table.end': 'End (UTC)',
      'measurementVisualization.table.action': 'Action',
      'measurementVisualization.chart.title': 'Chart of Selected Measurements',
      'measurementVisualization.chart.subtitle': 'Select a range in the graph to zoom.',
      'measurementVisualization.chart.orientation.vertical': 'Vertical',
      'measurementVisualization.chart.orientation.horizontal': 'Horizontal',
      'measurementVisualization.chart.error.noDataDescription':
        'For the choosen parameters no data for measurement visualization was found. Please adjust your parameters and try again.',
      'measurementVisualization.chart.error.onlyNullValuesTitle': 'No measurable values found.',
      'measurementVisualization.chart.error.onlyNullValuesDescription':
        'The selected parameters only contain empty values in the selected period. Please adjust your parameters and try again.',
      'measurementVisualization.parameters.tsoSelect': 'Übertragungsnetzbetreiber',
      'measurementVisualization.parameters.start': 'Start (UTC)',
      'measurementVisualization.parameters.end': 'End (UTC)',
      'measurementVisualization.parameters.aggregationInterval': 'Aggregation Interval',
      'measurementVisualization.parameters.measurmentParameters': 'Measurement Parameters',
      'measurementVisualization.parameters.current': 'Current',
      'measurementVisualization.parameters.voltage': 'Voltage',
      'measurementVisualization.parameters.measurementDevice': 'Measurement Device',
      'measurementVisualization.parameters.aggregationinterval.2hours': '2 hours',
      'measurementVisualization.parameters.aggregationinterval.10minutes': '10 minutes',
      'measurementVisualization.parameters.aggregationinterval.10minutes.voltage': '10 minutes voltage',
      'measurementVisualization.parameters.aggregationinterval.10minutes.current': '10 minutes current',
      'measurementVisualization.chart.placeholder.title': 'No entry selected.',
      'measurementVisualization.chart.placeholder.descri':
        'Choose an entry from the applied parameters to visualize it as a chart.',
      'measurementVisualization.parameters.modal.title': 'Apply parameters before switching?',
      'measurementVisualization.parameters.modal.description':
        'You have changed some parameters without applying it. Do you want to apply them before changing to an other entry?',
      'version.createNewVersion': 'Create New Version',
      'version.createNewVersion.tooltip': 'Available when `Active Until` is a past date.',
      'measurementExport.page.title': 'Measurement export',
      'measurementExport.page.subtitle': 'Choose parameters',
      'measurementExport.page.tso': 'Übertragungsnetzbetreiber',
      'measurementExport.parameters.start': 'Start (UTC)',
      'measurementExport.parameters.end': 'End (UTC)',
      'measurementExport.parameters.aggregationInterval': 'Aggregation Interval',
      'measurementExport.parameters.measurmentParameters': 'Measurment Parameters',
      'measurementExport.parameters.resetAll': 'Reset All',
      'measurementExport.parameters.checkData': 'Check Data',
      'measurementExport.parameters.placeholder.title': 'No parameters selected.',
      'measurementExport.parameters.placeholder.description':
        'Choose parameters above to check if data are available for exporting. Export is provided in csv format.',
      'measurementExport.parameters.aggregationinterval.c2h': '2 hours',
      'measurementExport.parameters.aggregationinterval.c10m_c': '10 minutes current',
      'measurementExport.parameters.aggregationinterval.c10m_v': '10 minutes voltage',
      'measurementExport.parameters.measurementDevice': 'Measurement Device',
      'measurementExport.parameters.noDataFound.title': 'No data found.',
      'measurementExport.parameters.noDataFound.description':
        'For the choosen parameters no data for exporting was found. \nPlease adjust your parameters above and check again.',
      'measurementExport.parameters.partialDataFound.title': 'Only partial data found.',
      'measurementExport.parameters.partialDataFound.description':
        'For the choosen parameters only partial data was found for exporting.\nPlease click the button below for exporting the data as CSV.\n\nPlease try again.',
      'measurementExport.parameters.dataFound.title': 'Data found.',
      'measurementExport.parameters.dataFound.description':
        'For the choosen parameters data was found for exporting.\nPlease click the button below for exporting the data as CSV.',
      'navbar.menu.monitoring.importedMeasurementsOverview': 'Import Overview',
      'importedMeasurementOverview.pageTitle': 'Overview of imported measurements',
      'importedMeasurementOverview.pageSubtitle':
        'Display missing data related to the specified timeframe and measurement devices',
      'importedMeasurementOverview.sectionTitle': 'Choose parameters',
      'importedMeasurementOverview.zoomOut': 'Zoom out',
      'importedMeasurementOverview.zoomIn': 'Zoom in',
      'importedMeasurementOverview.move': 'Move',
      'importedMeasurementOverview.selectPeriod': 'Select period',
      'importedMeasurementOverview.start': 'Start',
      'importedMeasurementOverview.end': 'End',
      'importedMeasurementOverview.reset': 'Reset',
      'importedMeasurementOverview.recordedData': 'Recorded Data',
      'measurementExport.parameters.changedDevices.title': 'Devices changed',
      'measurementExport.parameters.changedDevices.description':
        'Active devices have changed. Please run "Check Data" again',
      'info.legend': 'Legend',
      'info.legend.green': 'Value between 50% and 100%',
      'info.legend.orange': 'Value between 0% and 50%',
      'info.legend.red': 'Value between 0% and -∞%',
      'info.legend.gray': 'Value not available (n.a.)',
      'pqIndex.parameters.sectionTitle': 'Choose Parameters',
      'pqIndex.parameters.tsoSelect': 'TSO',
      'pqIndex.parameters.start': 'Start',
      'pqIndex.parameters.end': 'End',
      'pqIndex.parameters.limitSet': 'Limit set',
      'pqIndex.parameters.quickselectLabel': 'Measurement Parameter Quick Select',
      'pqIndex.parameters.allEvenHarmonics': 'All even harmonics',
      'pqIndex.parameters.allOddHarmonics': 'All odd harmonics',
      'pqIndex.parameters.measurmentParameters': 'Measurement Parameters',
      'pqIndex.parameters.measurementDevice': 'Measurement Device',
      'pqIndex.parameters.resetAll': 'Reset All',
      'pqIndex.parameters.apply': 'Apply',
      'pqIndex.title': 'PQ-Index',
      'pqIndex.subTitle': 'Only 2 dimensions can be displayed at a time.',
      'pqIndex.segmenteButtonMenu.measurement.substation': 'Substation',
      'pqIndex.segmenteButtonMenu.measurement.measurementPoint': 'Measurement Point',
      'pqIndex.segmenteButtonMenu.measurement.measurementDevice': 'Measurement Device',
      'pqIndex.segmenteButtonMenu.parameterCategory.measurementParameterCategory': 'Measurement Parameter Category',
      'pqIndex.segmenteButtonMenu.parameterCategory.measurementParameter': 'Measurement Parameter',
      'pqIndex.segmenteButtonMenu.timespan.totalPeriod': 'Total Period',
      'pqIndex.segmenteButtonMenu.timespan.years': 'Years',
      'pqIndex.segmenteButtonMenu.timespan.months': 'Months',
      'pqIndex.segmenteButtonMenu.timespan.calendarWeeks': 'Calendar Weeks',
      'pqIndex.segmenteButtonMenu.noParameterSelected.title': 'No parameters selected.',
      'pqIndex.segmenteButtonMenu.noParameterSelected.subtitle': 'Choose parameters to visualize data.',
      'harmonicsBackgroundLevel.pageTitle': 'Harmonic Background Level',
      'harmonicsBackgroundLevel.pageSubtitle': 'Visualize and export harmonic distortion levels by phases and orders',
      'harmonicBackgroundLevel.placeholderDescripttion': 'Choose parameters to visualize data.',
      'harmonicsBackgroundLevel.tso': 'TSO',
      'harmonicsBackgroundLevel.tso.isRequired': 'Please select at least 1 TSO',
      'harmonicsBackgroundLevel.start': 'Start',
      'harmonicsBackgroundLevel.end': 'End',
      'harmonicsBackgroundLevel.quickSelect': 'Measurement Parameter Quick Select',
      'harmonicsBackgroundLevel.allEvenHarmonics': 'All even harmonics',
      'harmonicsBackgroundLevel.allOddHarmonics': 'All odd harmonics',
      'harmonicsBackgroundLevel.measurementTypeLabel': 'Measurement Type',
      'harmonicsBackgroundLevel.measurementTypeLabel.isRequired': 'Please select a value',
      'harmonicsBackgroundLevel.measurementTypeLabelPlaceholder': 'Measurement Type',
      'harmonicsBackgroundLevel.phasePhase': 'Phase-Phase (LL)',
      'harmonicsBackgroundLevel.phaseGround': 'Phase-Ground (LE)',
      'harmonicsBackgroundLevel.harmonicOrder': 'Harmonic Order',
      'harmonicsBackgroundLevel.harmonicOrderPlaceholder': 'Choose value',
      'harmonicsBackgroundLevel.harmonicSwitchLabel': 'Show worst phase per order',
      'harmonicsBackgroundLevel.xAxisDescription': 'Harmonic order / Phase',
      'harmonicsBackgroundLevel.yAxisDescription': 'Distortion level (%)',
      'harmonicsBackgroundLevel.couldNotGetAllValuesWarning':
        'Some data could not be displayed due to an error. Available results are shown',
      'harmonicsBackgroundLevel.couldNotGetAnyValuesError': 'Data could not be displayed due to an error',
      TudPstOver50Rule: 'PST above 50',
      TudPstOver5For1DayRule: 'PST above 5 for one day',
      TudPltOver50Rule: 'PLT above 50',
      TudPltOver5For1DayRule: 'PLT above 5 for one day',
      TudHarmonicOver10FoldLimitFor1DayRule: '5. harmonic above ten-fold limit for one day',
      TudVoltage0For1HourRule: 'Voltage 0 for one hour',
      TudVoltageOutsideRangeFor1HourRule: 'Voltage over 10% deviation for one hour',
      TudUnbalanceOver10FoldLimitFor1DayRule: 'Unbalance above ten-fold limit for one day',
      TudVoltageMaxAboveLimit: 'Extremum of voltage above 110%',
      TudVoltageMinBelowLimit: 'Extremum of voltage below 90%',
    },
  },
  de: {
    translation: {
      'general.btn.home': 'Startseite',
      'general.btn.page': 'Seite',
      'general.btn.delete': 'Löschen',
      'general.btn.cancel': 'Abbrechen',
      'general.error.required': 'erforderlich',
      'general.error.requiredField': 'Das ist ein Pflichtfeld. Bitte ausfüllen.',
      'general.error.invalidFormat': 'Ungültige Zeichen. Erlaubte Zeichen sind a-zA-Z0-9äöüÄÖÜß-() und Leerzeichen',
      'general.error.invalidNumber': 'Ungültiges Zahlenformat',
      'general.error.onlyIntegerAllowed': 'Nur ganze Zahlen erlaubt',
      'general.error.characterLimit': 'Zeichenlimit ist 255',
      'general.error.dateSelect': 'Bitte Datum wählen',
      'general.error.valueSelect': 'Bitte Eintrag wählen',
      'general.error.noDataFound': 'Keine Daten gefunden.',
      'general.error.integer': 'Bitte Ganzzahl eingeben.',
      'general.error.positive': 'Bitte eine positive Zahl eingeben.',
      'general.error.latitude': 'Bitte im Format (-)xx.xxxxxx eingeben.',
      'general.error.longitude': 'Bitte im Format (-)xxx.xxxxxx eingeben.',
      'general.error.noiseThreshold': 'Bitte positive Zahl mit max. 3 Vorkommastellen und max. 5 Nachkommastellen eingeben.',
      'general.error.invalidDate': 'Datum darf nicht in der Zukunft sein',
      'general.error.invalidDateActiveTo': 'Datum muss nach Aktiv von sein',
      'general.error.maximumSelectedOptions': 'Die maximale Anzahl der ausgewählten Optionen beträgt',
      'general.error.noDataDescription':
        'Für die gewählten Parameter wurden keine Daten gefunden. Bitte passen Sie Ihre Parameter an und versuchen Sie es erneut.',
      'general.error.endAfterStart': 'Enddatum muss nach dem Startdatum liegen.',
      'general.error.timePeriodToSmall':
        'Das Startdatum muss weiter in der Vergangenheit liegen, der gewählte Zeitraum ist zu kurz.',
      'general.label.discard': 'Änderungen verwerfen',
      'general.label.resetAll': 'Verwerfen',
      'general.label.apply': 'Übernehmen',
      'management.general.discard': 'Änderungen verwerfen',
      'management.general.cancel': 'Abbrechen',
      'management.general.save': 'Speichern',
      'management.general.create': 'Hinzufügen',
      'general.tooltip.resetAll': 'Zurücksetzen',
      'general.tooltip.addNewRow': 'Neue Zeile hinzufügen',
      'general.tooltip.editRow': 'Bearbeiten',
      'general.tooltip.removeRow': 'Entfernen',
      'general.tooltip.duplicateRow': 'Duplizieren',
      'general.tooltip.export': 'Exportieren',
      'general.tooltip.exportAllRows': 'Alle Zeilen exportieren',
      'general.tooltip.exportAll': 'Alles exportieren',
      'general.label.noSubcategoryFound': 'Keine Unterkategorie',
      'general.grid.noRows': 'Keine Daten',
      'general.grid.noMatchingRows': 'Keine übereinstimmende Daten',
      'home.title': 'STARTSEITE',
      'page.title': 'Seite',
      'notFound.title': 'Nicht gefunden',
      'navbar.menu.monitoring': 'Datenmonitoring',
      'navbar.menu.monitoring.import': 'Datenimport',
      'navbar.menu.monitoring.measurementVisualization': 'Messwertvisualisierung',
      'navbar.menu.monitoring.measurementExport': 'Messwertexport',
      'navbar.menu.analyses': 'Analysen',
      'navbar.menu.analyses.pqIndex': 'PQ-Index',
      'navbar.menu.analyses.harmonicBackgroundLevel': 'Harmonischer Hintergrundpegel',
      'navbar.menu.analyses.anomalies': 'Anomalien',
      'navbar.menu.analyses.trend': 'Trend',
      'navbar.menu.analyses.correlation': 'Korrelationsanalyse',
      'navbar.menu.analyses.risk': 'Risiko',
      'navbar.menu.analyses.fluctuation': 'Schwankung',
      'navbar.menu.analyses.volatility': 'Volatilität',
      'navbar.menu.administration': 'Administration',
      'navbar.menu.administration.measuringPointManagement': 'Messpunktverwaltung',
      'navbar.menu.administration.masterData': 'Stammdatenverwaltung',
      'navbar.menu.administration.limitManagement': 'Grenzwertverwaltung',
      'navbar.menu.admin': 'Administration',
      'navbar.menu.deviceadministration': 'Messpunktverwaltung',
      'navbar.menu.masterdata': 'Stammdaten',
      'user.menu.changeUser': 'Benutzer wechseln',
      'user.menu.logOut': 'Abmelden',
      'user.menu.role': 'Rollen',
      'calendar.month.jan': 'Januar',
      'calendar.month.feb': 'Februar',
      'calendar.month.mar': 'März',
      'calendar.month.apr': 'April',
      'calendar.month.may': 'Mai',
      'calendar.month.jun': 'Juni',
      'calendar.month.jul': 'Juli',
      'calendar.month.aug': 'August',
      'calendar.month.sep': 'September',
      'calendar.month.oct': 'Oktober',
      'calendar.month.nov': 'November',
      'calendar.month.dec': 'Dezember',
      'calendar.button.accept': 'Auswahl übernehmen',
      'searchfield.placeholder': 'Suchen Sie nach Umspannwerk, Messpunkt oder Messgerät',
      'management.menu.collapseButton.tooltip.collapse': 'Alles einklappen',
      'management.menu.collapseButton.tooltip.expand': 'Alles ausklappen',
      'searchfield.search': 'Suche',
      'searchfield.noResult': 'Keine Treffer gefunden. Bitte passen Sie Ihre Suche an.',
      'management.menu.title': 'Messpunktverwaltung',
      'management.placeholderTitle': 'Noch keine Auswahl getroffen.',
      'management.placeholderDescription': 'Wählen Sie ein Umspannwerk, einen Messpunkt oder ein Messgerät aus.',
      'management.substation.tooltip.createSubstation': 'Neues Umspannwerk',
      'management.substation.create.title': 'Neues Umspannwerk anlegen',
      'management.substation.subtitle': 'Umspannwerk',
      'management.substation.designation': 'Bezeichnung',
      'management.substation.designation.error': 'Eine Benennung ist erforderlich',
      'management.substation.latitude': 'Breitengrad',
      'management.substation.latitude.error': 'Der Breitengrad muss eine Zahl zwischen -90 und 90 sein',
      'management.substation.longitude': 'Längengrad',
      'management.substation.longitude.error': 'Der Längengrad muss eine Zahl zwischen -180 und 180 sein',
      'management.substation.comment': 'Kommentar',
      'management.substation.comment.error': 'Kommentar ist zu lang',
      'management.substation.discard': 'Änderungen verwerfen',
      'management.substation.submit': 'Speichern',
      'management.measurementPoint.substationDeleteTitle': 'Umspannwerk löschen',
      'management.measurementPoint.substationDeleteContent':
        'Möchten Sie dieses Umspannwerk wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      'management.measurementPoint.substationCannotDelete':
        'Kann nicht gelöscht werden weil Messpunkte zugeordnet sind',
      'management.measurementPoint.active': 'Active',
      'management.measurementPoint.activFrom': 'Aktiv von',
      'management.measurementPoint.activeUntil': 'Aktiv bis',
      'management.measurementPoint.converterTypeVoltage': 'Wandlertyp Spannung',
      'management.measurementPoint.converterTypeCurrent': 'Wandlertyp Strom',
      'management.measurementPoint.transducerModelNotAvailable': '-',
      'management.measurementPoint.transducerModelDeleteTitle': 'Wandlertyp löschen',
      'management.measurementPoint.transducerModelDeleteContent':
        'Möchten Sie diesen Wandlertyp wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      'management.measurementPoint.transducerModelCannotDelete':
        'Kann nicht gelöscht werden weil es in Messpunkt verwendet wird',
      'management.measurementPoint.voltageLevel': 'Spannungsebene',
      'management.measurementPoint.connectionPointType': 'Anschlussstellentyp',
      'management.measurementPoint.connectionPointType.transformer': 'Transformator',
      'management.measurementPoint.connectionPointType.powerline': 'Leitung',
      'management.measurementPoint.connectionPointType.plant': 'Anlage',
      'management.measurementPoint.comment': 'Kommentar',
      'management.measurementPoint.create.button.tooltip': 'Neuer Messpunkt',
      'management.measurementPoint.create.title': 'Neuen Messpunkt anlegen',
      'management.measurementPoint.measurementPointDeleteTitle': 'Messpunkt löschen',
      'management.measurementPoint.measurementPointDeleteContent':
        'Möchten Sie diesen Messpunkt wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      'management.measurementPoint.measurementPointCannotDelete':
        'Kann nicht gelöscht werden weil Messgeräte zugeordnet sind',
      'management.measurementPoint.history.title': 'Messpunktverlauf',
      'management.measurementPoint.designation': 'Bezeichnung',
      'management.measurementPoint.subtitle': 'Messpunkt',
      'management.measurementPoint.activationStart': 'Aktiv von',
      'management.measurementPoint.activationEnd': 'Aktiv bis',
      'management.measurementPoint.voltageLevel.supportingText': 'Wert nur durch neue Version veränderbar',
      'management.measurementDevice.create.button.tooltip': 'Neues Messgerät',
      'management.measurementDevice.create.title': 'Neues Messgerät anlegen',
      'management.measurementDevice.history.title': 'Messgerätverlauf',
      'management.measurementDevice.designation': 'Bezeichnung',
      'management.measurementDevice.subtitle': 'Messgerät',
      'management.measurementDevice.technicalIdentifier': 'Technischer Name',
      'management.measurementDevice.error.invalidFormat': 'Ungültige Zeichen. Erlaubte Zeichen sind a-zA-ZäöüÄÖÜß0-9',
      'management.measurementDevice.activationStart': 'Aktiv von',
      'management.measurementDevice.activationEnd': 'Aktiv bis',
      'management.measurementDevice.manufactureYear': 'Herstellungsjahr',
      'management.measurementDevice.deviceTypes': 'Messgerätetyp',
      'management.measurementDevice.manufacturer': 'Hersteller',
      'management.measurementDevice.noiseLimit': 'Rauschgrenzen',
      'management.measurementDevice.includeForAnalyses.title': 'Messgerät für folgende Analysen einbeziehen:',
      'management.measurementDevice.includeForAnalyses.corellationLabel': 'Korrelationsanalyse',
      'management.measurementDevice.includeForAnalyses.anomalyDetectionLabel': 'Anomalieerkennung',
      'management.measurementDevice.comment': 'Kommentar',
      'management.measurementDevice.measurementDeviceDeleteTitle': 'Messgerät löschen',
      'management.measurementDevice.measurementDeviceDeleteContent':
        'Möchten Sie dieses Messgerät wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      'management.measurementDevice.measurementDeviceConfirmationDelete':
        'Beim Löschen dieses Messgeräts werden auch die hochgeladenen Messdaten gelöscht.',
      'masterdata.management': 'Stammdatenverwaltung',
      'masterdata.cancel': 'Abbrechen',
      'masterdata.delete': 'Löschen',
      'masterdata.transducer.modal.title': 'Neuer Wandlertyp',
      'masterdata.transducer.modal.titleEdit': 'Wandlertyp bearbeiten',
      'masterdata.transducer.section': 'Wandlertyp',
      'masterdata.transducer.table.manufacturer': 'Hersteller',
      'masterdata.transducer.table.model': 'Modell',
      'masterdata.transducer.table.transducerModel': 'Typ',
      'masterdata.transducer.table.transducerModel.combined': 'Kombi',
      'masterdata.transducer.table.transducerModel.voltage': 'Spannung',
      'masterdata.transducer.table.transducerModel.current': 'Strom',
      'masterdata.transducer.table.transmissionRatio': '',
      'masterdata.transducer.table.transmissionRatioVoltage': 'Übersetzungsverhältnis Spannung',
      'masterdata.transducer.table.transmissionRatioCurrent': 'Übersetzungsverhältnis Strom',
      'masterdata.transducer.table.transmissionRatioFormat': 'Bitte im Format Primär:Sekundär eingeben',
      'masterdata.transducer.table.voltagefrequencyDeviationPhaseAngle1': 'Spannung Phasenwinkelfehler 1% (Hz)',
      'masterdata.transducer.table.voltagefrequencyDeviationPhaseAngle10': 'Spannung Phasenwinkelfehler 10% (Hz)',
      'masterdata.transducer.table.voltagefrequencyDeviationMagnitude1': 'Spannung Amplitudenfehler 1% (Hz)',
      'masterdata.transducer.table.voltagefrequencyDeviationMagnitude10': 'Spannung Amplitudenfehler 10% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationPhaseAngle1': 'Strom Phasenwinkelfehler 1% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationPhaseAngle10': 'Strom Phasenwinkelfehler 10% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationMagnitude1': 'Strom Amplitudenfehler 1% (Hz)',
      'masterdata.transducer.table.currentfrequencyDeviationMagnitude10': 'Strom Amplitudenfehler 10% (Hz)',
      'masterdata.transducer.table.frequencyDeviationMagnitude1': 'Amplitudenfehler 1% (Hz)',
      'masterdata.transducer.table.frequencyDeviationMagnitude10': 'Amplitudenfehler 10% (Hz)',
      'masterdata.transducer.table.frequencyDeviationPhaseAngle1': 'Phasenwinkelfehler 1% (Hz)',
      'masterdata.transducer.table.frequencyDeviationPhaseAngle10': 'Phasenwinkelfehler 10% (Hz)',
      'masterdata.transducer.table.comment': 'Kommentar',
      'masterdata.transducer.modal.type.voltage': 'Spannung',
      'masterdata.transducer.modal.type.current': 'Strom',
      'masterdata.transducer.modal.type.combined': 'Kombi',
      'masterdata.voltageLevel.section': 'Spannungsebene',
      'masterdata.voltageLevel.modal.title': 'Neue Spannungsebene',
      'masterdata.voltageLevel.modal.titleEdit': 'Spannungsebene bearbeiten',
      'masterdata.voltageLevel.table.voltageLevelName': 'Name',
      'masterdata.voltageLevel.table.voltageLevelValue': 'Spannungswert LL (kV)',
      'masterdata.voltageLevel.table.comment': 'Kommentar',
      'masterdata.voltageLevel.deleteTitle': 'Spannungsebene löschen',
      'masterdata.voltageLevel.deleteContent':
        'Möchten Sie diese Spannungsebene wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      'masterdata.voltageLevel.cannotDelete': 'Kann nicht gelöscht werden weil es in Messpunkt verwendet wird',
      'masterdata.measuringDeviceType.section': 'Messgerätetyp',
      'masterdata.measuringDeviceType.modal.title': 'Neuer Messgerätetyp',
      'masterdata.measuringDeviceType.modal.titleEdit': 'Messgerätetyp bearbeiten',
      'management.measurementDevice.technicalIdentifierPlaceholder': 'Bitte Wert eingeben',
      'masterdata.measuringDeviceType.table.manufacturer': 'Hersteller',
      'masterdata.measuringDeviceType.table.model': 'Modell',
      'masterdata.measuringDeviceType.table.noiseLimitVoltage': 'Rauschgrenze Spannung (V)',
      'masterdata.measuringDeviceType.table.noiseLimitCurrent': 'Rauschgrenze Strom (A)',
      'masterdata.measuringDeviceType.noiseLimit.supportingText': 'Rauschgrenzen sind notwendig für Analysen',
      'masterdata.measuringDeviceType.table.comment': 'Kommentar',
      'masterdata.measuringDeviceType.deleteTitle': 'Messgerätetyp löschen',
      'masterdata.measuringDeviceType.deleteContent':
        'Möchten Sie diesen Messgerätetyp wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      'masterdata.measuringDeviceType.cannotDelete': 'Kann nicht gelöscht werden weil es in Messgerät verwendet wird',
      'upload.fileUpload.title': 'Dateien hochladen',
      'upload.tableHeader.uploadType': 'Upload-Typ',
      'upload.tableHeader.uploadTypeDescription': 'Upload-Typ: \n A = Automatisch \n M = Manuell',
      'upload.tableHeader.fileName': 'Dateiname',
      'upload.tableHeader.uploadedOn': 'Hochgeladen am',
      'upload.tableHeader.startPeriod': 'Zeitraum Beginn',
      'upload.tableHeader.endPeriod': 'Zeitraum Ende',
      'upload.tableHeader.substation': 'Umspannwerk',
      'upload.tableHeader.measuringDevice': 'Messgerät',
      'upload.tableHeader.aggregationInterval': 'Aggregationsintervall',
      'upload.tableHeader.validityCheck': 'Validitätscheck',
      'upload.tableHeader.status': 'Status',
      'upload.tableHeader.importStatus': 'Import',
      'upload.fileUpload.cancel': 'Abbrechen',
      'upload.fileUpload.closeWindow': 'Schließen',
      'upload.fileUpload.upload': 'Hochladen',
      'upload.fileUpload.selectFile.description':
        'Zu importierende Dateien hochladen. Die Dateien werden vor dem Import auf Validität überprüft.\nDas System unterstützt CSV-Dateien, die aus WinPQ oder WebPQ exportiert wurden.\nBei Benennung der Datei nach folgendem Schema kann das Messgerät und das Aggregationsintervall automatisiert zugewiesen werden.\nSchema des WinPQ-Dateinamens: "<SetupName>_<ExportDatum>_<TechnischerNameMessgerät>_<TechnischerNameAggregationsintervall>1_2.csv" wobei das Aggregationsintervall "C2h", "C10m_v" or "C10m_c" sein kann.\nSchema des WebPQ-Dateinamens: "<startDatum><endDatum><technischerNameAggregationsintervall>.csv" wobei das Aggregationsintervall "c2h", "c10m_v" or "c10m_c" sein kann. Das Messgerät wird aus dem Dateiinhalt extrahiert.',
      'upload.fileUpload.selectFile.added': 'Ausgewählte Dateien',
      'upload.fileUpload.uploadingFile.description': 'Ihre Dateien werden hochgeladen. Bitte warten...',
      'upload.fileUpload.uploadingFile.errorList.title': 'Bei folgenden Dateien ist ein Fehler aufgetreten:',
      'upload.fileUpload.uploadingFile.progress':
        '[currentFile] von [totalFiles] Dateien wurden erfolgreich hochgeladen.',
      'upload.fileUpload.uploadingFile.error': 'Fehler',
      'dropzone.description': '+ klicken um Dateien auszuwählen oder hierhin ziehen.',
      'dropzone.drag': 'Dateien hierhin ziehen...',
      'upload.searchPlaceholder': 'Suche',
      'upload.pageTitle': 'Datenimport',
      'homepage.title.development.local': 'Willkommen auf der Testumgebung\n der PQ-Plattform!',
      'homepage.title.dev': 'Willkommen auf der Testumgebung\n der PQ-Plattform!',
      'homepage.title.test': 'Willkommen auf der Testumgebung\n der PQ-Plattform!',
      'homepage.title.stg': 'Willkommen auf der Testumgebung\n der PQ-Plattform!',
      'homepage.title.prod': 'Willkommen auf der Produktivumgebung der PQ-Plattform!',
      'homepage.footer.description': 'In Kooperation mit',
      'homepage.description':
        'Auf dieser Testumgebung hast du die Möglichkeit, die neuesten Funktionen unserer Power Quality Plattform in einer sicheren Umgebung auszuprobieren.',
      'homepage.testCases.title': 'Neu zum Testen:',
      'homepage.testCases.first': '',
      'homepage.testCases.second': '',
      'homepage.testCases.third': '',
      'upload.fileUpload.uploadingFile.typeError': 'Es können nur CSV-Dateien hochgeladen werden.',
      'upload.detailedView.title': 'Details zum Messdaten-Import',
      'upload.detailedView.breadcrumb1': 'Datenimport',
      'upload.detailedView.breadcrumb2': 'Details',
      'upload.detailedView.substation': 'Umspannwerk',
      'upload.detailedView.measurementDevice': 'Messgerät',
      'upload.detailedView.pleaseSelect': 'Bitte wählen',
      'upload.detailedView.totalPeriod': 'Zeitraum',
      'upload.detailedView.aggregationInterval': 'Aggregationsintervall',
      'upload.detailedView.validityCheck': 'Validitätsprüfung',
      'upload.detailedView.importProcess': 'Importprozess',
      'upload.detailedView.validityCheckDetails.success':
        'Alle Prüfung erfolgreich abgeschlossen. Die Datei wurde importiert.',
      'upload.detailedView.validityCheckDetails.partial': 'Die Datei konnte nur teilweise importiert werden.',
      'upload.detailedView.validityCheckDetails.error': 'Die Datei konnte nicht importiert werden.',
      'upload.detailedView.validityCheckDetails.error.button.overwrite': 'Daten überschreiben',
      'upload.detailedView.validityCheckDetails.error.button.noOverwrite': 'Daten behalten',
      'upload.detailedView.validityCheckDetails.error.button.tryAgain': 'Erneut versuchen',
      'upload.detailedView.validityCheckDetails.unknown': 'Unbekannter Status',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.missing': 'Fehlende Informationen',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.additional':
        'Zusätzliche Informationen erforderlich um die Datei zu importieren',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.measuringDevice':
        'Es konnte kein Messgerät aus dem Dateinamen extrahiert werden. Bitte wählen Sie das passende aus der Liste aus.',
      'upload.detailedView.validityCheckDetails.deviceAndAggregation.aggregation':
        'Es konnte kein Aggregationsintervall aus dem Dateinamen extrahiert werden. Bitte wählen Sie das passende aus der Liste aus.',
      'upload.detailedView.validityCheckDetails.unknownColumns': 'Unbekannte Spaltennamen',
      'upload.detailedView.validityCheckDetails.columnsDetails':
        'Einige der Spaltennamen aus der importierten Datei konnten nicht im System gefunden werden.',
      'upload.detailedView.plausibilityCheck': 'Plausibilitätsprüfung',
      'upload.detailedView.plausibilityCheck.status.error.name': 'n/a',
      'upload.detailedView.plausibilityCheck.status.error.message':
        'Bei der Validitätsprüfung ist ein Fehler aufgetreten. Die Plausibilitätsprüfung wird nur nach einer fehlerfreien Validitätsprüfung durchgeführt.',
      'upload.detailedView.plausibilityCheck.status.waiting.name': 'Wartet',
      'upload.detailedView.plausibilityCheck.status.waiting.message':
        'Die Plausibilitätsprüfung wird nach der fehlerfreien Durchführung der Validitätsprüfung gestartet.',
      'upload.detailedView.plausibilityCheck.status.checking.name': 'In Bearbeitung',
      'upload.detailedView.plausibilityCheck.status.checking.message':
        'Die Plausibilitätsprüfung wird gerade durchgeführt.',
      'upload.detailedView.plausibilityCheck.status.plausible.name': 'Plausibel',
      'upload.detailedView.plausibilityCheck.status.plausible.message':
        'Die Plausibilitätsprüfung ist erfolgreich durchgelaufen. Alle Einträge sind plausibel.',
      'upload.detailedView.plausibilityCheck.button.retry': 'Erneut versuchen',
      'upload.detailedView.plausibilityCheck.status.plausible.error':
        'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut. Sollte das Problem weiterhin bestehen, können Sie ein Ticket einreichen.',
      'upload.detailedView.plausibilityCheck.status.notPlausible.name': 'Nicht plausibel',
      'upload.detailedView.plausibilityCheck.status.notPlausible.message':
        'Die Plausibilitätsprüfung ist erfolgreich durchgelaufen. Es wurden Zeitabschnitte mit unplausiblen Daten gefunden. Diese werden nicht für die Analysen verwendet. Falls gewünscht, kann diese Entscheidung in der Tabelle angepasst werden.',
      'upload.detailedView.plausibilityCheck.status.notPlausible.discardButton': 'Änderungen verwerfen',
      'upload.detailedView.plausibilityCheck.status.notPlausible.applyButton': 'Anwenden',
      'upload.detailedView.plausibilityCheck.dataGrid.id': 'ID',
      'upload.detailedView.plausibilityCheck.dataGrid.start': 'Start',
      'upload.detailedView.plausibilityCheck.dataGrid.end': 'Ende',
      'upload.detailedView.plausibilityCheck.dataGrid.plausibilityRule': 'Plausibilitätsregel',
      'upload.detailedView.plausibilityCheck.dataGrid.plausibility': 'Ist plausibel',
      'upload.detailedView.plausibilityCheck.error.title': 'Verarbeitungsfehler',
      'upload.detailedView.import.error.title': 'Verarbeitungsfehler',
      'upload.detailedView.import.error.content': 'Die Datei konnte nicht importiert werden.',
      'upload.validationStatus.error.unexpectedErrorUnknown': 'Unbekannter Fehler',
      'upload.validationStatus.error.unexpectedError': 'Es ist ein unbekannter Fehler aufgetreten.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploaded': 'Daten bereits vorhanden',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedDetails':
        'Für dieses Umspannwerk und dieses Messgerät liegen bereits Daten für den im hochgeladenen Datensatz angegebenen Zeitraum vor. Durch erneutes Importieren des Datensatzes können alle vorhandenen Werte innerhalb dieses Zeitraums ersetzt werden. Wenn Sie sich dafür entscheiden, die Daten nicht zu überschreiben, wird der Import mit den verbleibenden gültigen Daten fortgesetzt.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedInTotal_other':
        '\nInsgesamt werden <strong>{{count}} Einträge</strong> überschrieben.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedInTotal_one':
        '\nInsgesamt wird <strong>{{count}} Eintrag</strong> überschrieben.',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedModalTitel': 'Vorhandene Daten überschreiben',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedModalContent_other':
        'Die im System vorhandenen Werte werden durch die Daten aus der hochgeladenen \n Datei ersetzt. Insgesamt werden <strong>{{count}} Einträge</strong> innerhalb des betroffenen \n Zeitraums überschrieben. Diese Aktion kann nicht rückgängig gemacht werden.\n Möchten Sie wirklich fortfahren?',
      'upload.detailedView.validityCheckDetails.dataAlreadyUploadedModalContent_one':
        'Der im System vorhandenen Wert wird durch den Wert aus der hochgeladenen \n Datei ersetzt. Insgesamt wird <strong>{{count}} Eintrag</strong> innerhalb des betroffenen \n Zeitraums überschrieben. Diese Aktion kann nicht rückgängig gemacht werden.\n Möchten Sie wirklich fortfahren?',
      'upload.detailedView.validityCheckDetails.applicationError': 'Verarbeitungsfehler',
      'upload.detailedView.validityCheckDetails.applicationErrorDetails':
        'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut. Sollte das Problem weiterhin bestehen, können Sie ein Ticket einreichen.',
      'upload.detailedView.validityCheckDetails.duplicateRows': 'Doppelte Einträge',
      'upload.detailedView.validityCheckDetails.duplicateRowDetails':
        'Die zu importierende Datei enthält doppelte Einträge, die vor dem Import entfernt werden müssen.',
      'upload.detailedView.validityCheckDetails.invalidTimesStamps': 'Ungültige Zeitstempel',
      'upload.detailedView.validityCheckDetails.invalidTimestampDetails':
        'Die zu importierende Datei enthält ungültige Zeitstempel.',
      'upload.detailedView.validityCheckDetails.cannotParse': 'Verarbeitungsfehler',
      'upload.detailedView.validityCheckDetails.cannotParseDetails':
        'Die zu importierende Datei konnte nicht verarbeitet werden.',
      'upload.detailedView.validityCheckDetails.cannotImport': 'Verarbeitungsfehler',
      'upload.detailedView.validityCheckDetails.cannotImportDetails':
        'Die zu importierende Datei konnte nicht verarbeitet werden.',
      'upload.detailedView.accordion.infoContent.validation.inProgress':
        'Die importierte Datei wird auf Gültigkeit geprüft. Bitte warten.',
      'upload.detailedView.accordion.infoContent.validation.success':
        'Die importierte Datei wurde erfolgreich validiert.',
      'upload.detailedView.accordion.infoContent.validation.warning':
        'Die importierte Datei wurde validiert, jedoch mit Warnungen.',
      'upload.detailedView.accordion.infoContent.validation.error':
        'Die Validierung der importierten Datei kann aufgrund von Fehlern nicht fortgesetzt werden.',
      'upload.detailedView.accordion.infoContent.import.onHold':
        'Der Importprozess wartet, bis die Fehler bei der Gültigkeitsprüfung behoben wurden.',
      'upload.detailedView.accordion.infoContent.import.inProgress':
        'Die Daten aus der Datei werden importiert. Bitte warten.',
      'upload.detailedView.accordion.infoContent.import.error':
        'Der Import der Datei kann aufgrund von Fehlern nicht fortgesetzt werden.',
      'upload.detailedView.accordion.infoContent.import.success': 'Die Datei wurde erfolgreich importiert.',
      'upload.detailedView.accordion.infoContent.import.warning':
        'Die Datei wurde aufgrund von Fehlern nur teilweise importiert.',
      'upload.detailedView.accordion.infoContent.plausibility.onHold':
        'Die Plausibilitätsprüfung wartet, bis die vorherigen Prozesse abgeschlossen sind.',
      'upload.detailedView.accordion.infoContent.plausibility.inProgress':
        'Die importierte Datei wird auf Plausibilität geprüft. Bitte warten.',
      'upload.detailedView.accordion.infoContent.plausibility.error':
        'Die Plausibilitätsprüfung der importierten Datei kann aufgrund von Fehlern nicht fortgesetzt werden.',
      'upload.detailedView.accordion.infoContent.plausibility.success':
        'Die importierte Datei wurde erfolgreich auf Plausibilität geprüft.',
      'upload.detailedView.accordion.infoContent.plausibility.warning':
        'Die importierte Datei wurde auf Plausibilität geprüft. Es besteht die Möglichkeit, die Plausibilitätskriterien anzupassen. Nach der Anpassung muss die Quantilberechnung neu gestartet werden.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.onHold':
        'Die Quantilberechnung wartet, bis die vorherigen Prozesse abgeschlossen sind.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.inProgress':
        'Die Quantile werden berechnet. Bitte warten.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.success':
        'Die Quantile wurden erfolgreich berechnet und können nun für den PQ-Index verwendet werden.',
      'upload.detailedView.accordion.infoContent.quantileCalculation.error':
        'Die Quantilberechnung der importierten Datei kann aufgrund von Fehlern nicht fortgesetzt werden.',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent': 'Quantilberechnung',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.success.title':
        'Neu berechnen, wenn Änderungen an der Plausibilitätsprüfung vorgenommen wurden',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.success.content':
        'Wenn Sie die Plausibilitätskriterien manuell angepasst haben, können Sie den Prozess der Quantilberechnung hier neu starten.',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.success.buttonLabel':
        'Berechnung neu starten',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.error.title': 'Verarbeitungsfehler',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.error.content':
        'Es ist ein unbekannter Fehler aufgetreten. Bitte versuchen Sie es erneut. Sollte das Problem weiterhin bestehen, können Sie ein Ticket einreichen.',
      'upload.detailedView.accordion.infoContent.quantileCalculationContent.error.buttonLabel': 'Erneut versuchen',
      'upload.importStatus.waitingForImport': 'Wartet',
      'upload.importStatus.importing': 'In Bearbeitung',
      'upload.importStatus.imported': 'Importiert',
      'upload.importStatus.error': 'Fehler',
      'upload.importStatus.partiallyImported': 'Teilweise importiert',
      'upload.importStatus.commonStatus.onHold': 'Ausstehend',
      'upload.importStatus.commonStatus.inProgress': 'In Bearbeitung',
      'upload.importStatus.commonStatus.error': 'Fehler',
      'upload.importStatus.commonStatus.warning': 'Warnung',
      'upload.importStatus.commonStatus.success': 'Erfolgreich',
      'upload.importStatus.commonLabel.validation': 'Validierung: ',
      'upload.importStatus.commonLabel.import': 'Import: ',
      'upload.importStatus.commonLabel.plausibility': 'Plausibilitätsprüfung: ',
      'upload.importStatus.commonLabel.quantile': 'Quantilberechnung: ',
      'upload.validationStatus.imported': 'Importiert',
      'upload.validationStatus.error': 'Fehler',
      'upload.validationStatus.importing': 'Wird importiert',
      'upload.validationStatus.partial': 'Teilweise importiert',
      'upload.validationStatus.checkingValidity': 'In Bearbeitung',
      'upload.validationStatus.waitingForValidation': 'Wartet',
      'upload.type.manual': 'M',
      'upload.type.auto': 'A',
      'upload.noFile': 'Keine Datei ausgewählt',
      'upload.notAvailable': 'Nicht erkannt',
      'upload.aggregationinterval.2hours': '2 Stunden',
      'upload.aggregationinterval.10minutes': '10 Minuten',
      'upload.aggregationinterval.10minutes.voltage': '10 Minuten Spannungen',
      'upload.aggregationinterval.10minutes.current': '10 Minuten Ströme',
      'upload.chipFilter.quickFilters': 'Schnellfilter:',
      'upload.chipFilter.success': 'Erfolgreich',
      'upload.chipFilter.warning': 'Warnung',
      'upload.chipFilter.error': 'Fehler',
      'measurementVisualization.pageTitle': 'Wählen Sie Parameter',
      'measurementVisualization.visualizationSectionTitle': 'Ausgewählte Parameter',
      'measurementVisualization.table.measurementDevice': 'Messgerät',
      'measurementVisualization.table.aggregationInterval': 'Aggregationsintervall',
      'measurementVisualization.form.submit': 'Hinzufügen',
      'measurementVisualization.form.discard': 'Verwerfen',
      'measurementVisualization.table.start': 'Start (UTC)',
      'measurementVisualization.table.end': 'Ende (UTC)',
      'measurementVisualization.table.action': 'Aktion',
      'measurementVisualization.chart.title': 'Charts mit ausgewählten Messwerten',
      'measurementVisualization.chart.subtitle':
        'Durch Markieren eines Bereichs im Graph lässt sich die Ansicht vergrößern.',
      'measurementVisualization.chart.orientation.vertical': 'Vertikal',
      'measurementVisualization.chart.orientation.horizontal': 'Horizontal',
      'measurementVisualization.chart.error.noDataDescription':
        'Für das Messgerät wurden im gewählten Zeitraum keine Messwerte hochgeladen. Bitte wählen Sie einen anderen Zeitraum oder ein anderes Messgerät.',
      'measurementVisualization.chart.error.onlyNullValuesTitle': 'Keine Messwerte gefunden.',
      'measurementVisualization.chart.error.onlyNullValuesDescription':
        'Für das Messgerät wurden die gewählten Messgrößen im gewählten Zeitraum nicht gemessen bzw. hochgeladen. Bitte wählen Sie andere Messgrößen, ein anderes Messgerät oder einen anderen Zeitraum.',
      'measurementVisualization.parameters.tsoSelect': 'Übertragungsnetzbetreiber',
      'measurementVisualization.parameters.start': 'Start (UTC)',
      'measurementVisualization.parameters.end': 'Ende (UTC)',
      'measurementVisualization.parameters.aggregationInterval': 'Aggregationsintervall',
      'measurementVisualization.parameters.measurmentParameters': 'Messgrößen',
      'measurementVisualization.parameters.current': 'Ströme',
      'measurementVisualization.parameters.voltage': 'Spannungen',
      'measurementVisualization.parameters.measurementDevice': 'Messgerät',
      'measurementVisualization.parameters.aggregationinterval.2hours': '2 Stunden',
      'measurementVisualization.parameters.aggregationinterval.10minutes': '10 Minuten',
      'measurementVisualization.parameters.aggregationinterval.10minutes.voltage': '10 Minuten Spannungen',
      'measurementVisualization.parameters.aggregationinterval.10minutes.current': '10 Minuten Ströme',
      'measurementVisualization.chart.placeholder.title': 'Kein Eintrag ausgewählt',
      'measurementVisualization.chart.placeholder.descri':
        'Eintrag aus der Liste wählen, um die Messwerte zu visualisieren.',
      'measurementVisualization.parameters.modal.title': 'Änderungen übernehmen?',
      'measurementVisualization.parameters.modal.description':
        'Sollen die Änderungen an den Filterparametern übernommen werden?',
      'version.createNewVersion': 'Neue Version anlegen',
      'version.createNewVersion.tooltip': 'Bitte ein Datum in der Vergangenheit in Aktiv bis auswählen',
      'masterdata.generalPlaceholder': 'Bitte Wert eingeben',
      'masterdata.generalLimitationHasData':
        'Wert kann nicht geändert werden, da für die Entität Daten hochgeladen wurden',
      'measurementExport.page.title': 'Messwertexport',
      'measurementExport.page.subtitle': 'Wählen Sie Parameter',
      'measurementExport.page.tso': 'Übertragungsnetzbetreiber',
      'measurementExport.parameters.start': 'Start (UTC)',
      'measurementExport.parameters.end': 'Ende (UTC)',
      'measurementExport.parameters.aggregationInterval': 'Aggregationsintervall',
      'measurementExport.parameters.measurmentParameters': 'Messgrößen',
      'measurementExport.parameters.resetAll': 'Zurücksetzen',
      'measurementExport.parameters.checkData': 'Daten prüfen',
      'measurementExport.parameters.placeholder.title': 'Keine Filterparameter ausgewählt.',
      'measurementExport.parameters.placeholder.description':
        'Filterparameter auswählen, um zu prüfen, ob Daten für einen Export zur Verfügung stehen.',
      'measurementExport.parameters.aggregationinterval.c2h': '2 Stunden',
      'measurementExport.parameters.aggregationinterval.c10m_c': '10 Minuten Ströme',
      'measurementExport.parameters.aggregationinterval.c10m_v': '10 Minuten Spannungen',
      'measurementExport.parameters.measurementDevice': 'Messgeräte',
      'measurementExport.parameters.noDataFound.title': 'Keine Daten vorhanden.',
      'measurementExport.parameters.noDataFound.description':
        'Für die ausgewählten Filterparameter stehen keine Daten zum Export zur Verfügung. Bitte Filterparameter anpassen und erneut versuchen.',
      'measurementExport.parameters.partialDataFound.title': 'Nur teilweise Daten vorhanden.',
      'measurementExport.parameters.partialDataFound.description':
        'Für einige der ausgewählten Messgeräte stehen keine Daten zur Verfügung.\nBitte nachfolgenden Button klicken, um die vorhandenen Daten zu exportieren.',
      'measurementExport.parameters.dataFound.title': 'Daten vorhanden.',
      'measurementExport.parameters.dataFound.description':
        'Für die ausgewählten Filterparameter stehen Daten zum Export zur Verfügung.\nBitte nachfolgenden Button klicken, um die vorhandenen Daten zu exportieren.',
      'measurementExport.parameters.changedDevices.title': 'Messgeräte angepasst',
      'measurementExport.parameters.changedDevices.description':
        'Die ausgewählten Messgeräte wurden angepasst. Bitte erneut auf Daten prüfen.',
      'navbar.menu.monitoring.importedMeasurementsOverview': 'Messwertübersicht',
      'importedMeasurementOverview.pageTitle': 'Messwertübersicht',
      'importedMeasurementOverview.pageSubtitle':
        'Anzeige von importierten Messdaten für ausgewählten Zeitraum und Messgeräte',
      'importedMeasurementOverview.chart.placeholder.title': 'Kein Eintrag ausgewählt',
      'importedMeasurementOverview.chart.placeholder.descri': 'Parameter auswählen zur Visualisierung von Daten.',
      'importedMeasurementOverview.sectionTitle': 'Wählen Sie Parameter',
      'importedMeasurementOverview.zoomOut': 'Reinzoomen',
      'importedMeasurementOverview.zoomIn': 'Rauszoomen',
      'importedMeasurementOverview.move': 'Verschieben',
      'importedMeasurementOverview.selectPeriod': 'Zeitraum auswählen',
      'importedMeasurementOverview.start': 'Start',
      'importedMeasurementOverview.end': 'Ende',
      'importedMeasurementOverview.reset': 'Zurücksetzen',
      'importedMeasurementOverview.recordedData': 'Importierte Daten',
      'info.legend': 'Legende',
      'info.legend.green': 'Wert zwischen 50% und 100%',
      'info.legend.orange': 'Wert zwischen 0% und 50%',
      'info.legend.red': 'Wert zwischen -∞% und 0%',
      'info.legend.gray': 'Kein Wert',
      'pqIndex.parameters.sectionTitle': 'Wählen Sie Parameter',
      'pqIndex.parameters.tsoSelect': 'Übertragungsnetzbetreiber',
      'pqIndex.parameters.start': 'Start',
      'pqIndex.parameters.end': 'Ende',
      'pqIndex.parameters.limitSet': 'Grenzwertsatz',
      'pqIndex.parameters.quickselectLabel': 'Messgrößen Schnellauswahl',
      'pqIndex.parameters.allEvenHarmonics': 'Alle geraden Harmonischen',
      'pqIndex.parameters.allOddHarmonics': 'Alle ungeraden Harmonischen',
      'pqIndex.parameters.measurmentParameters': 'Messgrößen',
      'pqIndex.parameters.measurementDevice': 'Messgerät',
      'pqIndex.parameters.resetAll': 'Verwerfen',
      'pqIndex.parameters.apply': 'Hinzufügen',
      'pqIndex.title': 'PQ-Index',
      'pqIndex.subTitle': 'Es können jeweils nur 2 Dimensionen angezeigt werden. ',
      'pqIndex.segmenteButtonMenu.measurement.substation': 'Umspannwerk',
      'pqIndex.segmenteButtonMenu.measurement.measurementPoint': 'Messpunktverwaltung',
      'pqIndex.segmenteButtonMenu.measurement.measurementDevice': 'Messgerät',
      'pqIndex.segmenteButtonMenu.parameterCategory.measurementParameterCategory': 'Messgrößenkategorie',
      'pqIndex.segmenteButtonMenu.parameterCategory.measurementParameter': 'Messgrößen',
      'pqIndex.segmenteButtonMenu.timespan.totalPeriod': 'Gesamtzeitraum',
      'pqIndex.segmenteButtonMenu.timespan.years': 'Jahre',
      'pqIndex.segmenteButtonMenu.timespan.months': 'Monate',
      'pqIndex.segmenteButtonMenu.timespan.calendarWeeks': 'Kalenderwochen',
      'pqIndex.segmenteButtonMenu.noParameterSelected.title': 'Keine Parameter ausgewählt.',
      'pqIndex.segmenteButtonMenu.noParameterSelected.subtitle': 'Zur Datenvisualisierung bitte Parameter auswählen.',
      'harmonicsBackgroundLevel.pageTitle': 'Harmonischer Hintergrundpegel',
      'harmonicsBackgroundLevel.pageSubtitle':
        'Visualisierung und Export des harmonischen Hintergrundpegels nach Phasen und Ordnungen',
      'harmonicBackgroundLevel.placeholderDescripttion': 'Parameter auswählen zur Visualisierung von Daten.',
      'harmonicsBackgroundLevel.tso': 'Übertragungsnetzbetreiber',
      'harmonicsBackgroundLevel.tso.isRequired': 'Bitte wählen Sie mindestens einen Übertragungsnetzbetreiber aus.',
      'harmonicsBackgroundLevel.start': 'Start',
      'harmonicsBackgroundLevel.end': 'Ende',
      'harmonicsBackgroundLevel.quickSelect': 'Messgrößen Schnellauswahl',
      'harmonicsBackgroundLevel.allEvenHarmonics': 'Alle geraden Harmonischen',
      'harmonicsBackgroundLevel.allOddHarmonics': 'Alle ungeraden Harmonischen',
      'harmonicsBackgroundLevel.measurementTypeLabelPlaceholder': 'Messpfad',
      'harmonicsBackgroundLevel.measurementTypeLabel.isRequired': 'Bitte Einträg wählen',
      'harmonicsBackgroundLevel.measurementTypeLabel': 'Messpfad',
      'harmonicsBackgroundLevel.phasePhase': 'Leiter-Leiter (LL)',
      'harmonicsBackgroundLevel.phaseGround': 'Leiter-Erde (LE)',
      'harmonicsBackgroundLevel.harmonicOrder': 'Harmonische Ordnung',
      'harmonicsBackgroundLevel.harmonicOrderPlaceholder': 'Bitte Eintrag wählen',
      'harmonicsBackgroundLevel.harmonicSwitchLabel': 'Schlechteste Phase pro Ordnung anzeigen',
      'harmonicsBackgroundLevel.xAxisDescription': 'Harmonische Ordnung / Phase',
      'harmonicsBackgroundLevel.yAxisDescription': 'Hintergrundpegel (%)',
      'harmonicsBackgroundLevel.couldNotGetAllValuesWarning':
        'Einige Daten konnten aufgrund eines Fehlers nicht angezeigt werden. Verfügbare Ergebnisse werden dargestellt',
      'harmonicsBackgroundLevel.couldNotGetAnyValuesError':
        'Daten konnten aufgrund eines Fehlers nicht angezeigt werden',
      TudPstOver50Rule: 'PST über 50',
      TudPstOver5For1DayRule: 'PST über 5 für einen Tag',
      TudPltOver50Rule: 'PLT über 50',
      TudPltOver5For1DayRule: 'PLT über 5 für einen Tag',
      TudHarmonicOver10FoldLimitFor1DayRule: '5. Harmonische über 10-fachem Grenzwert für einen Tag',
      TudVoltage0For1HourRule: 'Spannung 0 für eine Stunde',
      TudVoltageOutsideRangeFor1HourRule: 'Spannung über 10% Abweichung für eine Stunde',
      TudUnbalanceOver10FoldLimitFor1DayRule: 'Unsymmetrie über 10-fachem Grenzwert für einen Tag',
      TudVoltageMaxAboveLimit: 'Extremwert der Spannung über 110%',
      TudVoltageMinBelowLimit: 'Extremwert der Spannung unter 90%',
    },
  },
};

export default translations;
